import { render, staticRenderFns } from "./VarFormModal.vue?vue&type=template&id=eedb6228"
import script from "./VarFormModal.vue?vue&type=script&lang=js"
export * from "./VarFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports